"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllHeroes = exports.countLiveHeroesWaitingForNextLevel = exports.countLiveHeroes = exports.setProgress = exports.update = exports.updateTick = exports.create = exports.EDiveAfterMoveAction = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var imports_1 = require("@lib/imports");
var common_sidecar_1 = require("@main/common-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var diveAi_common_sidecar_1 = require("@dive/ai/diveAi_common-sidecar");
var enumsAi_1 = require("@dive/ai/enumsAi");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var diveTileData_1 = require("@dive/tilemap/diveTileData");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var voyageProgressBars_sidecar_1 = require("@voyage/ui-cursors/voyageProgressBars-sidecar");
var spritesCrew_1 = require("../dive/spriteRecyclers/spritesCrew");
var diveCrew_attackable_sidecar_1 = require("./diveCrew_attackable-sidecar");
var diveCrew_hero_data_sidecar_1 = require("./diveCrew_hero_data-sidecar");
var diveCrew_misc_sidecar_1 = require("./diveCrew_misc-sidecar");
var diveCrew_movable_sidecar_1 = require("./diveCrew_movable-sidecar");
var diveCrew_weaponData_1 = require("./diveCrew_weaponData");
var EDiveAfterMoveAction;
(function (EDiveAfterMoveAction) {
    EDiveAfterMoveAction[EDiveAfterMoveAction["None"] = 0] = "None";
    EDiveAfterMoveAction[EDiveAfterMoveAction["Smash"] = 1] = "Smash";
    EDiveAfterMoveAction[EDiveAfterMoveAction["Open"] = 2] = "Open";
    EDiveAfterMoveAction[EDiveAfterMoveAction["PickUp"] = 3] = "PickUp";
})(EDiveAfterMoveAction = exports.EDiveAfterMoveAction || (exports.EDiveAfterMoveAction = {}));
function create(heroType) {
    // let b = voyageBodies.create()
    var data = diveCrew_hero_data_sidecar_1.diveCrew_hero_data.find(heroType);
    assert_sidecar_1.assert.notNil(data);
    var d = {
        data: data,
        fireExtinguishTimer: 0,
        useSystemTimer: 0,
        repairTimer: 0,
        oxygenTimer: 0,
        mopTimer: 0,
        medpackTimer: 0,
        statKills: 0,
        statDamageGiven: 0,
        statHeals: 0,
        statRepairs: 0,
        statFiresFought: 0,
        coffeeSteps: 0,
        // body: b,
        progressBar: null,
        // Dive
        afterMove_action: EDiveAfterMoveAction.None,
        afterMove_target_i: 0,
        afterMove_target_j: 0,
        afterMove_target_id: 0,
    };
    return d;
}
exports.create = create;
function updateTick(obj) {
    if (obj.isDead || obj.isDying) {
        return;
    }
    assert_sidecar_1.assert.notNil(obj.heroState);
    if (obj.isDownStairs) {
        return;
    }
    var tile = diveTilemap_sidecar_1.diveTilemap.getSafeIIJ(obj);
    if (tile && tile.tile1.type === diveTileData_1.EDiveTile.StairsDown) {
        if (diveCrew_movable_sidecar_1.diveCrew_movable.isNotMoving(obj)) {
            obj.isDownStairs = true;
            diveCrew_sidecar_1.diveCrew.setTile(obj, null);
            obj.stairsFadeTimeSeconds = 1;
            return;
        }
    }
    // TODO: move elsewhere?
    // Avoid bunching
    if (diveCrew_movable_sidecar_1.diveCrew_movable.isNotMoving(obj)) {
        // Are there too many monsters here?
        if (diveCrew_sidecar_1.diveCrew.countAtIJ(obj.i, obj.j, function (c) { return diveCrew_movable_sidecar_1.diveCrew_movable.isNotMoving(c); }) >
            1) {
            // TODO: move off
            var nextTile = diveAi_common_sidecar_1.diveAi_common.getBestTileOneStepTowards(obj, null);
            if (nextTile) {
                diveCrew_movable_sidecar_1.diveCrew_movable.syncTryPathOffset(obj, nextTile.i - obj.i, nextTile.j - obj.j);
            }
            return;
        }
    }
    diveCrew_movable_sidecar_1.diveCrew_movable.updateTick(obj);
    diveCrew_attackable_sidecar_1.diveCrew_attackable.updateTick(obj, enumsAi_1.EAiTargetType.Enemy);
}
exports.updateTick = updateTick;
// const shrinkSprite = (fr: ISPD): ISPD => {
//   // Reduce dimensions of fr by one pixel
//   let fr2 = { ...fr }
//   fr2.x++
//   fr2.y++
//   fr2.w -= 2
//   fr2.h -= 2
//   return fr2
// }
function update(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var d = obj.heroState;
    assert_sidecar_1.assert.notNil(d);
    setProgress(obj, 0);
    if (obj.isDead || obj.isDying) {
        return;
    }
    var alpha = 1;
    if (obj.isDownStairs) {
        obj.stairsFadeTimeSeconds -= ds;
        alpha = obj.stairsFadeTimeSeconds;
        alpha = mathUtils_sidecar_1.mathUtils.clamp1(alpha);
        if (alpha <= 0) {
            return;
        }
    }
    else {
        if (obj.stairsFadeTimeSeconds > 0) {
            obj.stairsFadeTimeSeconds -= ds;
            alpha = 1 - obj.stairsFadeTimeSeconds;
            alpha = mathUtils_sidecar_1.mathUtils.clamp1(alpha);
        }
    }
    diveCrew_movable_sidecar_1.diveCrew_movable.update(obj);
    // --- START DIVE
    // Render for dive
    var heroData = d.data;
    assert_sidecar_1.assert.notNil(heroData);
    var frames = heroData.frames;
    // Idle frame
    var bounceIdx = diveSimulationManager_sidecar_1.diveSimulationManager.get2frameIdx();
    if (diveCrew_sidecar_1.diveCrew.isStunned(obj)) {
        bounceIdx = 0;
    }
    var frame = frames.idle[bounceIdx % frames.idle.length];
    var isDead = false;
    // Dead!
    if (obj.hitpoints <= 0) {
        frame = frames.dead[0];
        isDead = true;
    }
    if (!isDead) {
        // Add attacking frame
        var wd = obj.weaponState;
        if (wd) {
            if (wd.state === diveCrew_weaponData_1.EDiveWeaponState.PreAttack1) {
                frame = frames.attackR[0];
            }
            if (wd.state === diveCrew_weaponData_1.EDiveWeaponState.PreAttack2) {
                frame = frames.attackR[1];
            }
            if (wd.state === diveCrew_weaponData_1.EDiveWeaponState.PostAttack) {
                frame = frames.attackR[2] || frames.attackR[0];
            }
            if (wd.state === diveCrew_weaponData_1.EDiveWeaponState.Reloading) {
                frame = frames.idle[0]; // TODO: reloading frame?
            }
        }
    }
    if (!frame) {
        frame = frames.idle[0];
    }
    diveCrew_misc_sidecar_1.diveCrew_misc.renderShadow(obj, d.data.renderShadow);
    var img = spritesCrew_1.spritesCrew.getNext(obj.x, obj.y, frame);
    img.scaleX = obj.isFlipped ? -img.scaleX : img.scaleX;
    img.alpha = alpha;
    // --- END DIVE
    // TODO: refactor all of this after
    var status = voyageGameStatus_sidecar_1.voyageGameStatus.get();
    status.crewCount++;
    // const sleepEffectTime = 0.5
    // obj.sleepyEffectTimer += ds
    // if (obj.sleepyEffectTimer > sleepEffectTime) {
    //   obj.sleepyEffectTimer -= sleepEffectTime
    //   if (obj.isPassedOut) {
    //     let p = voyageParticles.create('zzz', obj.x, obj.y)
    //     p.image.tint = voyageColors.red
    //   } else {
    //     if (obj.energy <= 60) {
    //       let p = voyageParticles.create('zzz', obj.x, obj.y)
    //       p.image.tint = voyageColors.yellow
    //     }
    //   }
    // }
    // obj.energyTimer += ds
    // const energyTime = 10
    // const energyRate = 1
    // if (!obj.isPassedOut) {
    //   if (obj.energyTimer > energyTime) {
    //     // Some randomness in energy
    //     obj.energyTimer -= rando.fj(energyTime, 0.25)
    //     diveCrew.hurtEnergy(obj, energyTime * energyRate)
    //   }
    // } else {
    //   const passedOutTime = 10
    //   const passedOutEnergyRate = -5
    //   obj.passedOutTimer += ds
    //   if (obj.passedOutTimer > passedOutTime) {
    //     obj.passedOutTimer = 0
    //     diveCrew.hurtEnergy(obj, passedOutTime * passedOutEnergyRate)
    //   }
    // }
    // const oxygenTime = 2
    // d.oxygenTimer += ds
    // if (d.oxygenTimer > oxygenTime) {
    //   d.oxygenTimer -= oxygenTime
    //   if (status.oxygen < 15) {
    //     if (rando.chance(0.25)) {
    //       let phrases = [
    //         'It is tough to breathe',
    //         'Someone check life support',
    //         '',
    //       ]
    //       diveCrew.say(obj, rando.sample(phrases))
    //     }
    //   }
    //   if (status.oxygen < 5) {
    //     let phrases = [
    //       '*gasp*',
    //       'Oxygen!',
    //       'O2!',
    //       'I need air!',
    //       'Get to life support quick!',
    //       '',
    //       '',
    //     ]
    //     diveCrew.say(obj, rando.sample(phrases))
    //     diveCrew.hurt(obj, 5, EVoyageCrewDamageType.NoOxygen, 0) //'Asphyxiation')
    //     voyageParticles.createMultiple('oxygen', obj.x, obj.y, rando.i(1, 3))
    //   }
    // }
    // TODO: does this make it so most effects don't work while moving?
    if (obj.pathResult) {
        return; // moving
    }
    // if (obj.items.length > 0) {
    //   // Mopping (per client)
    //   if (diveCrew.isHolding(obj, EVoyageCarryableType.Mop)) {
    //     const cleaningTime = 0.25
    //     d.mopTimer += ds
    //     if (d.mopTimer > cleaningTime) {
    //       d.mopTimer -= cleaningTime
    //       let closestSplatter: IVoyageSplatter | null = null as any
    //       let closestSplatterDist = 48
    //       l.forEach(voyageSplatters.getAll(), (c) => {
    //         if (!c.isDead) {
    //           let dist = distanceUtil.distanceNormalXY(c.image, obj)
    //           if (dist < closestSplatterDist) {
    //             closestSplatterDist = dist
    //             closestSplatter = c
    //           }
    //         }
    //       })
    //       if (closestSplatter) {
    //         voyageSplatters.kill(closestSplatter)
    //       }
    //     }
    //   }
    //   // Cannot heal at low oxygen to avoid exploit
    //   if (
    //     diveCrew.isHolding(obj, EVoyageCarryableType.Medpack) &&
    //     status.oxygen >= 10
    //   ) {
    //     const medpackTime = 0.25
    //     d.medpackTimer += ds
    //     if (d.medpackTimer > medpackTime) {
    //       d.medpackTimer -= medpackTime
    //       let closestCrew: IVoyageCrew | null = null as any
    //       let closestCrewDist = 48
    //       l.forEach(diveCrew.getAll(), (c) => {
    //         if (
    //           !c.isDead &&
    //           c !== obj &&
    //           c.hitpoints < 110 &&
    //           c.type === EVoyageCrewType.Crew
    //         ) {
    //           let dist = distanceUtil.distanceNormalXY(c.image, obj)
    //           if (dist < closestCrewDist) {
    //             closestCrewDist = dist
    //             closestCrew = c
    //           }
    //         }
    //       })
    //       if (closestCrew) {
    //         let toHeal = closestCrew
    //         voyageParticles.createMultiple('heal', toHeal.x, toHeal.y, 1)
    //         if (voyageWebsockets.getIsHost()) {
    //           let healRate = 10
    //           let newHitpoints = toHeal.hitpoints + medpackTime * healRate
    //           if (newHitpoints > 125) {
    //             newHitpoints = 125
    //           }
    //           voyageMessageCrewHurt.sendMessageAndImmediatelyExecute({
    //             crewId: toHeal.id,
    //             newHitpoints: newHitpoints,
    //             type: EVoyageCrewDamageType.Heal,
    //             byCrewId: obj.id,
    //           })
    //         }
    //       }
    //     }
    //   }
    // }
    var tCur = diveTilemap_sidecar_1.diveTilemap.getSafeIIJ(obj);
    if (tCur) {
        // voyageSystems.useSystem(obj, tCur)
    }
    // if (voyageGameStatus.get().hasFire.isActive) {
    //   d.fireExtinguishTimer += ds
    //   let fireExtinguishTime = 1.5
    //   if (diveCrew.isHolding(obj, EVoyageCarryableType.Extinguisher)) {
    //     fireExtinguishTime /= 3
    //   }
    //   if (d.fireExtinguishTimer > fireExtinguishTime) {
    //     d.fireExtinguishTimer -= rando.fj(fireExtinguishTime, 0.25)
    //     let tHere = diveTilemap.getSafeIJ(obj)
    //     if (tHere) {
    //       // if (tHere.fire) {
    //       //   const fireDamage = 25 * fireExtinguishTime
    //       //   diveCrew.hurt(obj, fireDamage, EVoyageCrewDamageType.Fire, 0)
    //       // }
    //     }
    //     for (let i = 0; i < _offsets9.length; i++) {
    //       let os = _offsets9[i]
    //       let tCheck = diveTilemap.getSafeOffset(obj, os[0], os[1])
    //       if (tCheck) {
    //         // if (tCheck.fire) {
    //         //   diveCrew.hurt(
    //         //     tCheck.fire,
    //         //     8,
    //         //     EVoyageCrewDamageType.FireExtinguisher,
    //         //     obj.id,
    //         //   )
    //         //   voyageSounds.playFireExtinguisher()
    //         //   voyageParticles.createMultiple(
    //         //     'fire-extinguisher',
    //         //     tCheck.x,
    //         //     tCheck.y + 8,
    //         //     5,
    //         //   )
    //         //   // Only one
    //         //   break
    //         // }
    //       }
    //     }
    //   }
    // }
    // if (voyageGameStatus.get().hasBreach.isActive) {
    //   d.repairTimer += ds
    //   let repairTime = 0.75
    //   if (diveCrew.isHolding(obj, EVoyageCarryableType.Wrench)) {
    //     repairTime /= 3
    //   }
    //   if (d.repairTimer > repairTime) {
    //     d.repairTimer -= rando.fj(repairTime, 0.25)
    //     for (let i = 0; i < _offsets9.length; i++) {
    //       let os = _offsets9[i]
    //       let tCheck = voyageTilemap.getSafeOffset(obj, os[0], os[1])
    //       if (tCheck) {
    //         if (tCheck.breach) {
    //           diveCrew.hurt(
    //             tCheck.breach,
    //             7,
    //             EVoyageCrewDamageType.Repair,
    //             obj.id,
    //           )
    //           voyageSounds.playRepair()
    //           voyageParticles.createMultiple(
    //             'heal-hull',
    //             tCheck.x,
    //             tCheck.y + 8,
    //             rando.i(2, 4),
    //           )
    //           // Only one
    //           break
    //         }
    //       }
    //     }
    //   }
    // }
}
exports.update = update;
function setProgress(obj, v) {
    // assert.notNil(obj.crewState)
    if (obj.heroState) {
        if (!obj.heroState.progressBar) {
            obj.heroState.progressBar = voyageProgressBars_sidecar_1.voyageProgressBars.create();
        }
        voyageProgressBars_sidecar_1.voyageProgressBars.setValue(obj.heroState.progressBar, v);
    }
}
exports.setProgress = setProgress;
function countLiveHeroes() {
    var count = 0;
    imports_1.l.forEach(diveCrew_sidecar_1.diveCrew.getAll(), function (c) {
        if (c.type === diveCrew_1.EVoyageCrewType.Hero) {
            if (!diveCrew_sidecar_1.diveCrew.isDeadish(c)) {
                count++;
            }
        }
    });
    return count;
}
exports.countLiveHeroes = countLiveHeroes;
function countLiveHeroesWaitingForNextLevel() {
    var count = 0;
    imports_1.l.forEach(diveCrew_sidecar_1.diveCrew.getAll(), function (c) {
        if (c.type === diveCrew_1.EVoyageCrewType.Hero) {
            if (!diveCrew_sidecar_1.diveCrew.isDeadish(c)) {
                if (c.isDownStairs) {
                    count++;
                }
            }
        }
    });
    return count;
}
exports.countLiveHeroesWaitingForNextLevel = countLiveHeroesWaitingForNextLevel;
function getAllHeroes() {
    return diveCrew_sidecar_1.diveCrew.getAllFiltered(function (c) { return c.type === diveCrew_1.EVoyageCrewType.Hero; });
}
exports.getAllHeroes = getAllHeroes;
